import { render, staticRenderFns } from "./ImprestBreadcrumb.vue?vue&type=template&id=00a58bd1&scoped=true"
import script from "./ImprestBreadcrumb.vue?vue&type=script&lang=js"
export * from "./ImprestBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./ImprestBreadcrumb.vue?vue&type=style&index=0&id=00a58bd1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a58bd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VContainer})
